import Riders from './Riders';
import * as React from 'react';
import Drivers from './Drivers';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import FleetAdmins from './FleetAdmins';
import CreateAdmin from './CreateAdmin';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Users() {
  let query = useQuery();
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const [value, setValue] = React.useState(0);

  if (!auth.profile?.usertype) return;


  React.useEffect(() => {
    let driver = query.get("driver")
    if (driver) {
      setValue(1)
    }
  }, [query]);


  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          aria-label="tabs type users"
          onChange={(event, newValue) => {
            setValue(newValue)
          }}
        >
          <Tab style={{ marginRight: "20px" }} label={t('riders')} {...a11yProps(0)} />
          <Tab style={{ marginRight: "20px" }} label={t('drivers')} {...a11yProps(1)} />

          {auth.profile?.usertype !== 'fleetadmin' &&
            <Tab label={t('alladmin')} {...a11yProps(2)} />
          }
          {process.env.REACT_APP_FRANQUIA === 'true' && auth.profile?.usertype !== 'fleetadmin' &&
            <Tab style={{ marginRight: "20px" }} label={t('fleetadmins')} {...a11yProps(3)} />
          }
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Riders />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Drivers />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <CreateAdmin />
      </TabPanel>

      {process.env.REACT_APP_FRANQUIA === 'true' &&
        <TabPanel value={value} index={3}>
          <FleetAdmins />
        </TabPanel>
      }
    </Box >
  );
}